module.exports = __webpack_public_path__ + "img/zwgg.04c71587.png";